

























































































































































































































































































































































































































































declare var window: any;
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { vxm } from '@/store.vuex';
import Referrals from './../../Referrals.vue';
import MyJobsPager from './../../MyJobsPager.vue';
import { Pager } from './../../../models/jobs/pager';
import { ApplyRequestWrapper } from '../../../models/jobs/jobapply';
import { Referral } from '../../../models/referrals/referral';
import VueToastr from '@deveodk/vue-toastr';
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';
import { UserJob } from '../../../models/jobs/userjob';
import { UserJobListRequest } from '../../../models/jobs/userjoblistrequest';
import { WorkFlowStepSubmitRequest } from './JobSubmitFLow';
import { Job } from '@/models/jobs/job';
import ReferralProgramusd from '../../SvgIcons/ReferralProgramusd.vue';
import ReferralProgramgbp from '../../SvgIcons/ReferralProgramgbp.vue';
import JobMainInfo from '@/components/Commons/JobMainInfo.vue';
import offerLetterPopUp from './offerLetterPopUp.vue';
import {
  JOBPOSTING_ASSIGNMENT_STATUS_APPLIED,
  JOBPOSTING_ASSIGNMENT_STATUS_OFFERED,
  JOBPOSTING_ASSIGNMENT_STATUS_OFFER_EXTENDED,
  JOBPOSTING_ASSIGNMENT_STATUS_OFFER_WITHDRAW,
  JOBPOSTING_ASSIGNMENT_STATUS_ACCEPTED,
  JOBPOSTING_ASSIGNMENT_STATUS_REFUSED,
  JOBPOSTING_ASSIGNMENT_STATUS_STANDBY,
  JOBPOSTING_ASSIGNMENT_STATUS_REVOKED,
  MYJOBS_REJECTED_MESSAGE,
  MYJOBS_ACCEPTED_MESSAGE,
  APPLICATION_STATUS,
} from './../MyJobsConstants';

import JobIntermediateStep from '../../JobApplicationIntermediateSteps/JobIntermediateStep.vue';
import { Facility } from '../../../models/jobs/facility';
import { JobTagConfig } from './../../../models/jobs/jobtagconfig';
import { faBorderNone } from '@fortawesome/free-solid-svg-icons';


Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 3000,
});

@Component({
  name: 'MyJoblisting',
  components: {
    JobMainInfo,
    Referrals,
    MyJobsPager,
    ReferralProgramusd,
    ReferralProgramgbp,
    JobIntermediateStep,
    offerLetterPopUp,
  },
})
export default class MyJoblisting extends Vue {
  private jobListing: UserJob[] = [];
  private expandedJobs: number[] = [];

  $wlToastr: any;
  $moment: any;
  private isFullDataArrived: boolean = false;
  private isRotated: boolean = true;
  public myJobs: any[] = this.jobsData;
  public hasDataFetched: boolean = false;
  private bookmarks: any[] = [];
  private jobDetails: Job = new Job();
  private test: boolean = false;
  private reasonCodes: any[] = [];
  private jobId: any;
  private reasonCodeId = -1;
  private intermidateJobId: any;
  private comment: any = '';
  private inOfferRefused: boolean = false;
  private offerLetterURL = '';
  private docGUID = '';
  private onShowReasonCodes: boolean = false;
  private bookMarksInitialized: any[] = [];
  @Prop({ default: '01', type: String })
  jobstatus;
  @Prop({ default: false, type: Boolean })
  isSaveJob;
  private resultcount: number = 0;
  public reqObj: UserJobListRequest = {
    sessionToken: '123',
    jobStatus: this.jobstatus,
    resultSize: 50,
    resultPage: 1,
    resultCount: 0,
  };
  JOBPOSTING_ASSIGNMENT_STATUS_REVOKED = JOBPOSTING_ASSIGNMENT_STATUS_REVOKED;
  JOBPOSTING_ASSIGNMENT_STATUS_OFFERED = JOBPOSTING_ASSIGNMENT_STATUS_OFFERED;
  JOBPOSTING_ASSIGNMENT_STATUS_OFFER_EXTENDED = JOBPOSTING_ASSIGNMENT_STATUS_OFFER_EXTENDED;
  JOBPOSTING_ASSIGNMENT_STATUS_OFFER_WITHDRAW = JOBPOSTING_ASSIGNMENT_STATUS_OFFER_WITHDRAW;
  JOBPOSTING_ASSIGNMENT_STATUS_ACCEPTED = JOBPOSTING_ASSIGNMENT_STATUS_ACCEPTED;
  JOBPOSTING_ASSIGNMENT_STATUS_REFUSED = JOBPOSTING_ASSIGNMENT_STATUS_REFUSED;
  JOBPOSTING_ASSIGNMENT_STATUS_STANDBY = JOBPOSTING_ASSIGNMENT_STATUS_STANDBY;

  currentStatus(job) {
    return APPLICATION_STATUS[job.jobPostingAssignmentStatus] || 'APPLICATION SUBMITTED';
  }

  get canShowJobDetails() {
    return !vxm.configs.getGlobalConfigValue(
      'HIDE_JOB_DETAILS_IN_JOB_LIST_PAGE',
    );
  }
  get isOfferLetterDisabled(){
    return vxm.jobs.BrandingInfo.OFFER_LETTER_DISABLED;
  }

  getDistance(job: UserJob) {
    if (job.distance) {
      if (job.distance > 0.1) {
        return job.distance.toFixed(1);
      } else {
        return '< 0.1';
      }
    } else {
      return '0.0';
    }
  }

  getJobTags(jobTags: string) {
    if (jobTags) {
      let jobTagValues = new Set(jobTags);
      let jobTagConfigs: JobTagConfig[] = vxm.jobs.JobTagConfigs;
      if (jobTagConfigs && jobTagConfigs.length > 0) {
        return jobTagConfigs
          .filter((tagConf) => jobTagValues.has(tagConf.tagName))
          .sort((a, b) => a.sequence - b.sequence);
      }
    }
    return [];
  }

  offerLetterViewPopUp(job) {
    var disableButtons = false;
    if (JOBPOSTING_ASSIGNMENT_STATUS_ACCEPTED === job.subStatus || JOBPOSTING_ASSIGNMENT_STATUS_ACCEPTED === job.jobPostingAssignmentStatus
      || JOBPOSTING_ASSIGNMENT_STATUS_REFUSED === job.subStatus || JOBPOSTING_ASSIGNMENT_STATUS_REFUSED === job.jobPostingAssignmentStatus) {
      disableButtons = true
    }
    this.jobDetails = new Job();
    this.jobDetails.jobPostingId = job.jobPostingId
    this.jobDetails.step = job.step,
      this.jobDetails.jobPostingStatus = job.jobPostingStatus,
      this.$modal.show(
        offerLetterPopUp,
        {
          header: 'View Offer',
          okText: 'Update',
          reasonCodes: this.reasonCodes,
          docGuid: this.docGUID,
          disableButtons: disableButtons,
          offerLetterUrl: this.offerLetterURL,
          rejectOffer: this.offerLetterRejectOffer,
          acceptOffer: this.offerLetterAcceptOffer,
          intermidateJobId: this.intermidateJobId,
          // reasonCodeOnReject:this.reasonCodeOnReject,
          // onShowReasonCodes:this.onShowReasonCodes,
          job: this.jobDetails
        },
        {
          height: 'auto',
          clickToClose: false,
          class: 'mainclass',
        },
      );
  }

  offerLetterAcceptOffer() {

    this.acceptOffer(this.jobDetails)
  }
  offerLetterRejectOffer() {
    if (this.reasonCodes.length > 0) {
      this.comment = this.jobDetails.comment;
      this.reasonCodeId = this.jobDetails.reasonCodeId;
    }
    this.rejectOffer(this.jobDetails)
  }
  convertHtmlToPlainText(content: string) {
    if (!content) {
      return;
    }
    let convertedText = content.replace(/(<([^>]+)>)/gi, '');
    if (convertedText.indexOf('&nbsp;')) {
      const regex = /&nbsp;/gi;
      convertedText = convertedText.replace(/&nbsp;/g, ' ');
    } else if (convertedText.indexOf('&nbsp')) {
      const regex = /&nbsp/gi;
      convertedText = convertedText.replace(/&nbsp/g, ' ');
    }
    return convertedText;
  }
  goTodetail(job) {
    vxm.users.Rudderstack.trackEvent("My Jobs Job Selected", {
      pathDetails: `click_on_job_through_my_jobs ${this.isSaveJob ? 'savedJobs' : 'myJobstatus'}`,
      JobPostingId: job.jobPostingId,
      JobPostingTitle: job.jobPostingName,
      JobAssignmentStatus: this.jobstatus
    })
    const jid = job.jobPostingId;
    vxm.jobs.setJobID(parseInt(jid, 10));
    localStorage.jobviewpage = this.isSaveJob ? true : false;
    vxm.jobs.setJobAdminMessage(job.adminComment);
    vxm.jobs.setUserJob(job);
    this.$router.push({ path: `/jobdetails/${jid}${this.isSaveJob ? '?goBackRoute=/savedJobs' : '?goBackRoute=/myjobstatus'}` });
    vxm.jobs.setJobAdminMessage(
      vxm.referrals.ReferralWrapper.referralEventDescription,
    );
  }

  get OfferRefusedReasonCode() {
    // Add the value in branding file when enabled
    // return vxm.jobs.BrandingInfo.OFFER_REFUSED_REASON_CODE;
    return false;
  }
  get offerLetterEnabled() {
    // Add the value in branding file when enabled
    // return vxm.jobs.BrandingInfo.OFFER_MANAGEMENT;
    return false;
  }

  async getOfferLetter(job) {
    const jid = job.jobPostingAssignmentId;
    const resp = await vxm.jobs.fetchOfferLetter(jid).then((response: any) => {
      this.offerLetterURL =
        vxm.configs.getGlobalConfigValue('CANDIDATE_PORTAL_CONTEXT_URL') +
        response.data.data.docFullPath;
      this.docGUID = response.data.data.docGUID;
    });
    this.offerLetterViewPopUp(job);
  }

  getJobTagStyle(jobTagObj) {
    let styleObj = {};
    if (
      jobTagObj &&
      jobTagObj.meta &&
      jobTagObj.meta.style &&
      jobTagObj.meta.style.fontColor
    ) {
      styleObj['color'] = jobTagObj.meta.style.fontColor;
    }
    if (
      jobTagObj &&
      jobTagObj.meta &&
      jobTagObj.meta.style &&
      jobTagObj.meta.style.backgroundColor
    ) {
      styleObj['background'] = jobTagObj.meta.style.backgroundColor;
    }
    if (
      jobTagObj &&
      jobTagObj.meta &&
      jobTagObj.meta.style &&
      jobTagObj.meta.style.backgroundColorOpacity
    ) {
      styleObj['opacity'] = jobTagObj.meta.style.backgroundColorOpacity;
    }
    return styleObj;
  }

  setNavigation(path: string) {
    this.$cookies.set('NavigateTo_ID', path, 600);
  }

  handleScroll(event) {
    if (!this.isFullDataArrived) {
      let listElm: any = document.querySelector('.my-job-listing');
      if (
        listElm['scrollTop'] + listElm.clientHeight + 34 >=
        listElm.scrollHeight
      ) {
        if (this.isRotated) {
          this.fetchMyJobs();
        }
      }
    }
  }

  goTodetailWithTitle(jid: string, jTitle: string, facility: Facility) {
    vxm.jobs.setJobID(parseInt(jid, 10));
    let city = facility.city ? facility.city.trim() : facility.city;
    localStorage.jobviewpage = true;
    let jobTitleSlug = this.jobTitleCitySlug(jTitle, city);
    this.$router.push({
      name: 'JobdetailsSlug',
      params: { JobID: jid, JobSlug: jobTitleSlug },
    });
  }

  jobTitleCitySlug(jTitle: string, city: string): string {
    let slug = '';
    slug = jTitle
      .split(' ')
      .join('-')
      .toLowerCase();
    if (city !== null && city.length > 0) {
      slug = slug.concat('-in-').concat(city.toLowerCase());
    }
    slug = slug.replace(/---|-\/-/g, '-');
    return slug;
  }

  bookmarkClass(job) {
    if (
      this.jobstatus === '04' &&
      job.bookmarkStatus &&
      job.bookmarkStatus === 'A' &&
      job.hasAppliedJob != true
    ) {
      return 'fa fa-bookmark secondary-color';
    } else {
      return 'fa fa-bookmark-o remove-color';
    }
  }

  goToReferral(job) {
    let jid = job.jobPostingId;
    vxm.referrals.setJobID(parseInt(jid, 10));
    vxm.referrals.setRefferedJob(job.jobPostingName);
    if (vxm.users.isLoggedIn === false) {
      this.$router.push({ name: 'JobShare', params: { JobID: jid } });
    } else {
      const referral = new Referral();
      referral.jobPostingId = parseInt(jid, 10);
      referral.userFullName =
        vxm.users.myUserProfile.firstName +
        ' ' +
        vxm.users.myUserProfile.lastName;
      referral.email = vxm.users.myUserProfile.email;
      referral.referralCode = '';
      referral.companyCode = vxm.jobs.BrandingInfo.companycode;
      referral.referredJobLocation = job.facility.name;
      console.log(referral);
      vxm.referrals.setReferral(referral);
      vxm.referrals.jobShareReferral(referral);
    }
  }

  getJobReferralProgramExists(job) {
    if (job.companyReferralIncentive !== null) {
      return job.companyReferralIncentive.companyReferralIncentiveName !== 'NA'
        ? true
        : false;
    }
    return false;
  }

  toggleReferralIndex(idx: number) {
    const i = this.expandedJobs.findIndex((elm) => {
      return elm === idx;
    });
    if (i === -1) {
      this.expandedJobs.push(idx);
    } else {
      this.expandedJobs.splice(i, 1);
    }
  }

  mounted() {
    this.myJobs = [];
    this.clickToClose();
    this.fetchMyJobs();
  }

  isExpanded(idx: number): boolean {
    const i = this.expandedJobs.findIndex((elm) => {
      return elm === idx;
    });
    if (i === -1) {
      return false;
    } else {
      return true;
    }
  }

  get jobsData() {
    return vxm.jobs.SavedJobs;
  }

  @Watch('jobsData')
  onJobDataPropertyChanged(value: any, oldValue: any) {
    console.log(value, '**New Valuew');
    this.myJobs = value;
    if (this.jobstatus === '04') {
      this.initializeBookmarkedJobs();
    }
  }

  @Watch('jobstatus')
  onPropertyChanged(value: string, oldValue: string) {
    if (value !== oldValue) {
      this.myJobs = [];
      this.hasDataFetched = false;
      this.isFullDataArrived = false;
      this.isRotated = true;
      this.fetchMyJobs();
      this.reqObj.jobStatus = value;
    }
  }

  destroyed() {
    // vxm.jobs.setJobListings([]);
    const pg = new Pager();
    vxm.jobs.setJobPager(pg);
  }
  async fetchMyJobs() {

    this.clickToClose();


    this.hasDataFetched = false;
    if (this.isRotated) {
      this.isRotated = false;
      this.reqObj.resultPage =
        this.myJobs && this.myJobs.length
          ? Math.ceil(this.myJobs.length / this.reqObj.resultSize)
          : 1;
      if (this.jobstatus === '04') {
        this.reqObj.resultSize = 10;
      }
      this.$modal.show('survey-spinner');
      await vxm.jobs.getMyJobStatus(this.reqObj).then(
        (response: any) => {
          this.$modal.hide('survey-spinner');
          if (response.data.reasonCodes != null) {
            this.reasonCodes = response.data.reasonCodes;
          }
          if (this.isSaveJob) {
            this.myJobs = response.data.userJobs.filter(function (job) {
              return job.hasAppliedJob != true;
            });
          } else {
            this.myJobs = response.data.userJobs;
          }
          if (this.myJobs.length === response.data.resultCount) {
            this.isFullDataArrived = true;
          }
          if (this.jobstatus === '04') {
            this.initializeBookmarkedJobs();
          }
          this.isRotated = true;
          this.hasDataFetched = true;
        },
        (error) => { },
      );
    }
    const currentURL = window.location.href;

    // Extract the 'offered' value
    const offeredIndex = currentURL.indexOf('offered=');
    const offered = currentURL.substr(offeredIndex + 8).split('/')[0];

    // Extract the 'id' parameter
    const idIndex = currentURL.lastIndexOf('/');
    const jobId = currentURL.substr(idIndex + 1);


    if (jobId != null) {
      for (var i = 0; i < this.myJobs.length; i++) {
        if (this.myJobs[i].jobPostingId === parseInt(jobId)) {
          this.getOfferLetter(this.myJobs[i])
        }
      }
    }
  }

  initializeBookmarkedJobs() {
    this.myJobs = this.myJobs.map((job) => {
      if (!this.bookMarksInitialized.includes(job.jobPostingId)) {
        this.bookmarks.push({
          action: 'A',
          type: '01',
          objectId: job.jobPostingId,
        });
        this.bookMarksInitialized.push(job.jobPostingId);
      }
      job['bookmarkStatus'] = 'A';
      return job;
    });
  }

  bookmarkJob(job: any) {
    let jobs = this.bookmarks.filter(
      (bookmark) => bookmark.objectId === job.jobPostingId,
    );
    if (jobs && jobs.length > 0) {
      for (let bookmark of this.bookmarks) {
        if (job.jobPostingId == bookmark.objectId) {
          if (job.bookmarkStatus && job.bookmarkStatus === 'A') {
            vxm.users.Rudderstack.trackEvent("Job Unsaved", {
              JobPostingTitle: job.jobPostingName,
              JobPostingId: job.jobPostingId
            })
            job.bookmarkStatus = 'D';
            bookmark.action = 'D';
          } else if (job.bookmarkStatus && job.bookmarkStatus === 'D') {
            job.bookmarkStatus = 'A';
            bookmark.action = 'A';
          }
        }
      }
    } else if (job.bookmarkStatus && job.bookmarkStatus === 'A') {
      job.bookmarkStatus = 'D';
      this.bookmarks.push({
        action: 'D',
        type: '01',
        objectId: job.jobPostingId,
      });
    } else if (job.bookmarkStatus && job.bookmarkStatus === 'D') {
      job.bookmarkStatus = 'A';
      this.bookmarks.push({
        action: 'A',
        type: '01',
        objectId: job.jobPostingId,
      });
    }

    let bookmarkIcon = this.$refs['bookmark_' + job.jobPostingId];
    if (job.bookmarkStatus && job.bookmarkStatus === 'A') {
      bookmarkIcon[0].classList = ['fa fa-bookmark secondary-color bookmark-icon'];
    } else if (job.bookmarkStatus && job.bookmarkStatus === 'D') {
      bookmarkIcon[0].classList = [
        'fa fa-bookmark-o remove-color bookmark-icon',
      ];
    }
    let req = {
      sessionToken: '13223',
      bookmarks: this.bookmarks,
    };
    if (this.bookmarks && this.bookmarks.length > 0) {
      vxm.jobs.bookmarkJob(req).then((resp) => {
        this.fetchMyJobs();
      });
    }
  }

  get UserJobListRequest() {
    return vxm.jobs.UserJobListRequest;
  }

  get isLoggedIn() {
    return vxm.users.isLoggedIn;
  }

  get referralEnabled() {
    return vxm.configs.isReferralEnabled('REFERRAL_ENABLED');
  }

  get hideMyJobsStatus() {
    return vxm.configs.getGlobalConfigBooelanValue('HIDE_MY_JOB_STATUS');
  }

  renderDate(xDate: number): string {
    if (vxm.jobs.getCompanyDateFormat) {
      return this.$moment(xDate).format(
        vxm.jobs.getCompanyDateFormat.toUpperCase(),
      );
    }
    return this.$moment(xDate).format('DD-MMM-YYYY');
  }

  acceptOffer(job) {
    console.log("job isss" + job)
    this.clickToClose();
    let workFlowStepSubmitRequest: WorkFlowStepSubmitRequest = {
      workflowStepUserData: {
        refUrl: '',
        jobPostingID: job.jobPostingId,
        step: job.step,
        jobPostingAssignmentStatus: job.jobPostingStatus,
        workflowStepActionResponses: [
          {
            payOfferAction: {
              offerAccepted: true,
              rejectComment: '',
              allowOverlappingTimeSlots: null,
            },
            actionCode: '00',
          },
        ],
        allSlotsSelected: false

      },
      sessionToken: '23',
      comment: '',
      offerRefusedReason: NaN,
      offerRefusedPage: '',
    };
    this.$modal.show('survey-spinner');
    vxm.jobs.submitJobFlow(workFlowStepSubmitRequest).then(
      (response: any) => {
        this.myJobs = [];
        this.isFullDataArrived = false;
        this.$modal.hide('survey-spinner');
        this.fetchMyJobs();
        this.$wlToastr('success', MYJOBS_ACCEPTED_MESSAGE, this.$t('MyJobListing_OfferedJobs'));
      },
      (error: any) => {
        this.$modal.hide('survey-spinner');
      },
    );
    this.comment = '';
    this.reasonCodeId = -1;
  }

  get onReject() {
    return this.test;
  }
  clickToClose() {
    this.onShowReasonCodes = false;
    this.intermidateJobId = null;
    if (!this.inOfferRefused) {
      this.comment = '';
      this.reasonCodeId = -1;
    }
  }

  reasonCodeOnReject(job) {
    this.onShowReasonCodes = true;
    this.intermidateJobId = job.jobPostingId;
    console.log(this.intermidateJobId)
  }

  rejectOffer(job) {
    this.inOfferRefused = true;
    this.clickToClose();
    if (this.reasonCodes.length == 0 || this.reasonCodeId == -1) {
      this.comment = '';
      this.reasonCodeId = NaN;
    }
    let workFlowStepSubmitRequest: WorkFlowStepSubmitRequest = {
      workflowStepUserData: {
        refUrl: '',
        jobPostingID: job.jobPostingId,
        step: job.step,
        jobPostingAssignmentStatus: job.jobPostingStatus,
        workflowStepActionResponses: [
          {
            payOfferAction: {
              offerAccepted: false,
              rejectComment: '',
              allowOverlappingTimeSlots: null,
            },
            actionCode: '00',
          },
        ],
        allSlotsSelected: false
      },
      sessionToken: '23',
      comment: this.comment,
      offerRefusedReason: this.reasonCodeId,
      offerRefusedPage: 'TalentPortal',
    };

    this.$modal.show('survey-spinner');
    vxm.jobs.submitJobFlow(workFlowStepSubmitRequest).then(
      (response: any) => {
        this.inOfferRefused = false;
        this.myJobs = [];
        this.$modal.hide('survey-spinner');
        this.isFullDataArrived = false;
        this.fetchMyJobs();
        this.$wlToastr('success', MYJOBS_REJECTED_MESSAGE, this.$t('MyJobListing_OfferedJobs'));
      },
      (error: any) => {
        this.$modal.hide('survey-spinner');
      },
    );
    this.comment = '';
    this.reasonCodeId = -1;
  }

  truncate(str: string, len: number, suffix: string) {
    if (str && str.length > len) {
      return str.substring(0, len) + suffix;
    } else {
      return str;
    }
  }

  renderDOW(dow: number): string {
    let day = '';
    switch (dow) {
      case 0:
        day = 'Sun';
        break;
      case 1:
        day = 'Mon';
        break;
      case 2:
        day = 'Tue';
        break;
      case 3:
        day = 'Wed';
        break;
      case 4:
        day = 'Thu';
        break;
      case 5:
        day = 'Fri';
        break;
      case 6:
        day = 'Sat';
    }
    return day;
  }
  getCompanyLogoUrl(companyCode: string): string {
    return vxm.jobs.getCompanyLogoUrl(companyCode);
  }

  goToUpload(jid: string) {
    vxm.users.Rudderstack.trackEvent("Job Apply Selected", {
      JobPostingId: jid,
    })
    const vm = this;
    if (!vxm.users.getToken) {
      this.setNavigation('JobDetails:' + jid);
      this.$router.push({ name: 'Login' });
    } else {
      vxm.jobs.setJobID(parseInt(jid, 10));
      const jobApply = new ApplyRequestWrapper();
      jobApply.accessToken = vxm.users.getToken;
      jobApply.applyRequest.jobPostingId = parseInt(jid, 10);

      jobApply.applyRequest.companyCode = vxm.jobs.BrandingInfo.companycode;
      const respPromise: any = vxm.jobs.getNexSteps(jobApply);
      this.$modal.show('survey-spinner');
      Promise.all([respPromise]).then((values) => {
        this.$modal.hide('survey-spinner');
        const resp = values[0] && values[0].data ? values[0].data : values[0];
        if (resp) {
          this.processJobApplicationResponse(resp, jid);
        }
      });
    }
  }

  processJobApplicationResponse(apply, jid) {
    if (apply.questionareInfo) {
      localStorage.hasBranchedQuestions = apply.questionareInfo.hasBranchedQuestions;
      localStorage.questionTemplate = apply.questionareInfo.questionTemplateId;
    }
    if (apply.nextPage === 'otpauthentication') {
      this.$router.push({ name: 'Verification' });
      this.setNavigation('JobDetails:' + jid);
    }
    // error code 1001 resume
    if (
      apply.errorCode === '1001' ||
      apply.nextPage === 'questionnaire' ||
      apply.nextPage === 'supportinginfo'
    ) {
      localStorage.nextpage =
        apply.errorCode === '1001' ? 'resume' : apply.nextPage;
      localStorage.jobviewpage = '';
      this.goTodetail2(jid);
      return;
    }

    if (apply.errorCode === '1002') {
      this.showMessage(apply, jid);
      return;
    }

    if (apply.nextPage === 'success') {
      this.showMessage(apply, jid);
      return;
    }
    this.showMessage(apply, jid);
  }

  goTodetail2(jid: string) {
    vxm.jobs.setJobID(parseInt(jid, 10));
    this.$router.push({ name: 'Jobdetails', params: { JobID: jid } });
  }

  goToFindJobs() {
    this.$router.push('/findjobs');
  }

  showMessage(value, jid) {
    if (value) {
      if (!value.success) {
        if (value.errorCode === '1002') {
          const errorMessageText = value.errorMessage;
          this.$wlToastr('error', errorMessageText, this.$t('MyJobListing_JobApplication'));
        }
      } else {
        if (value.nextPage === 'success') {
          const successMessage = this.$t('jobs.successfully.applied');
          vxm.users.Rudderstack.trackEvent("Job Apply Submitted", {
            JobPostingId: jid,
          })
          this.$wlToastr('success', successMessage, this.$t('MyJobListing_JobApplication'));
          vxm.jobs.setAppliedJob(jid);
          this.$router.push({ name: 'JobApplicationSuccess', params: { jid } });
        }
      }
    }
  }

  getFirstCapitalletter(value: string): string {
    if (!value) return '';
    value = value.toString();
    return value
      .trim()
      .charAt(0)
      .toUpperCase();
  }
}
